var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"resize",rawName:"v-resize:debounce",value:(_vm.onResize),expression:"onResize",arg:"debounce"}]},[_c('div',{staticClass:"container",attrs:{"id":_vm.elId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }